import { Box, Typography, useTheme } from '@mui/material';

const SectionHeading = ({ overline, title, subtitle, align = 'center', maxWidth = 720, sx }) => {
  const theme = useTheme();
  const isCenter = align === 'center';

  return (
    <Box
      sx={{
        textAlign: align,
        mb: { xs: 5, md: 7 },
        mx: isCenter ? 'auto' : 0,
        maxWidth: isCenter ? maxWidth : 'none',
        ...sx,
      }}
    >
      {overline && (
        <Typography
          variant="overline"
          sx={{
            color: theme.palette.primary.main,
            display: 'block',
            mb: 1.5,
            fontSize: '0.8rem',
          }}
        >
          {overline}
        </Typography>
      )}
      <Typography variant="h2" component="h2" sx={{ color: 'text.primary', mb: subtitle ? 2 : 0 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="subtitle1"
          sx={{ color: 'text.secondary', maxWidth, mx: isCenter ? 'auto' : 0 }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeading;
